import { render, staticRenderFns } from "./product-description.vue?vue&type=template&id=e77cff86&scoped=true&"
import script from "./product-description.vue?vue&type=script&lang=js&"
export * from "./product-description.vue?vue&type=script&lang=js&"
import style0 from "./product-description.vue?vue&type=style&index=0&id=e77cff86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77cff86",
  null
  
)

export default component.exports